var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24748",
    "data-name": "\\uC0AC\\uAC01\\uD615 24748",
    width: 24,
    height: 24,
    fill: "#f1f1f1",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_576",
    "data-name": "\\uD328\\uC2A4 576",
    transform: "translate(-126.487 -18.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10728",
    "data-name": "\\uD328\\uC2A4 10728",
    d: "M144.15,36.566h-4.533a.838.838,0,0,1-.837-.838V29.89a.838.838,0,0,1,.837-.838h4.533a.838.838,0,0,1,.837.838v5.838A.838.838,0,0,1,144.15,36.566Zm-4.367-1h4.2v-5.5h-4.2Zm-2.425,1h-4.534a.839.839,0,0,1-.837-.838V32.494a.839.839,0,0,1,.837-.838h4.534a.839.839,0,0,1,.837.838v3.235A.839.839,0,0,1,137.358,36.566Zm-4.368-1h4.2v-2.9h-4.2Zm4.368-4.481h-4.534a.839.839,0,0,1-.837-.838V24.4a.839.839,0,0,1,.837-.838h4.534a.839.839,0,0,1,.837.838v5.839A.839.839,0,0,1,137.358,31.08Zm-4.368-1h4.2v-5.5h-4.2Zm11.162-1.6h-4.539a.836.836,0,0,1-.834-.835V24.4a.836.836,0,0,1,.834-.835h4.539a.836.836,0,0,1,.835.835v3.24A.836.836,0,0,1,144.152,28.477Zm-4.369-1.005h4.2v-2.9h-4.2Zm4.369-2.9h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.79e7fe991806a10c04c4bf9326ff3620.svg";
export { ForwardRef as ReactComponent };